import $http from './http'
import config from './config'

export default {
  name: 'btrip',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getBtripTexts(id) {
    return $http.get(this.getUrl(`/BtripText/BtripTexts/${id}`));
  },
  getBtripTask(data) {
    return $http.post(this.getUrl(`/BtripTask/GetBtripTask`), data);
  },
  getTripRule(data) {
    return $http.post(this.getUrl(`/TripRule/GetTripRule`), data);
  },
  getBtripTextList(data) {
    return $http.post(this.getUrl(`/BtripText/list`), data);
  },
  saveTripRejectReason(data) {
    return $http.post(this.getUrl('/BtripTask/Update'), data);
  },
  getTripFlowDetail(id) {
    return $http.get(this.getUrl(`/TripFlow/Details/${id}`));
  },
  getProjectList(data){
    return $http.post(this.getUrl('/Project/List'),data);
},

}



// WEBPACK FOOTER //
// ./src/apis/btripApi.js